<template>
  <div class="modal" tabindex="-1" ref="modal" id="delete-challenge-modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Delete</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>Are you sure you want to delete this challenge?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-dismiss="modal">No</button>
          <form v-if="challenge" method="post" :action="`/admin/challenges/${challenge.id}/delete`">
            <input type="hidden" name="_token" :value="csrf">
            <button type="submit" class="btn btn-danger">Yes</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '../../event-bus';

export default {
  data() {
    return {
      challenge: null,
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    }
  },
  mounted() {
    eventBus.$on('deleteChallengeModalOpened', this.deleteModal);
  },
  methods: {
    deleteModal(challenge) {
      this.challenge = challenge;
      $(this.$refs.modal).show();
    }
  }
}
</script>